/* eslint-disable @cspell/spellchecker */
import { AuthObject } from '@issuemanager/legacy/common';
import {
  artemisTestingOrganization,
  auditOnPlatformDevOrganization,
} from '../test-organizations';
import {
  authorizationTestOrganization,
  devSandboxOrganization,
  devSolarisMonitoringOrganization,
  localSandboxOrganization,
  productionBudapestTestOrganization,
  stagingSolarisTestingOrganization,
} from '../test-organizations/issue-manager-test-organizations';
import { riskManagerOrganization } from '../test-organizations/risk-manager-test-organizations';
import { getLaunchpadUser, getLaunchpadUsers } from './test-user-base-info';
import { LaunchpadUser } from './types';

// Production users
export const productionAdminTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+admin@diligent.com',
  name: 'Javier Zabala',
  highbondId: 'ScmNozWdshzvNGk5THG7',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac0',
  organization: productionBudapestTestOrganization,
  password: 'asdQWE123',
});

export const productionTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+user@diligent.com',
  name: 'Javier Zabala',
  highbondId: 'HaYCVgX7nGSGQ-_KpUzp',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac1',
  organization: productionBudapestTestOrganization,
  password: 'asdQWE123',
});

// Staging users
export const stagingAdminTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+test@diligent.com',
  name: 'Javier Zabala',
  highbondId: 'yGdcH_dxTPjM5usxJz8D',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac0',
  organization: stagingSolarisTestingOrganization,
  password: 'asdQWE123',
});

export const stagingTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+test-user@diligent.com',
  name: 'Javier Zabala',
  highbondId: 'Xjoz9kkRmuHRtvuppX_f',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac1',
  organization: stagingSolarisTestingOrganization,
  password: 'asdQWE123',
});

// Dev environment users
export const devAdminTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+test-admin@diligent.com',
  name: 'JavierAdmin Zabala',
  highbondId: 'naSMQEm9yDqP4LYFshxe',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107aca',
  organization: devSandboxOrganization,
  userType: 'admin',
  secondaryOrganizations: [
    riskManagerOrganization,
    auditOnPlatformDevOrganization,
    artemisTestingOrganization,
  ],
  password: 'asdQWE1234',
});

export const devTestUser: LaunchpadUser = getLaunchpadUser({
  email: 'jzabala+test-regular@diligent.com',
  name: 'Javier Zabala',
  highbondId: 'jD7RAv3Zxr6ysWHSmwqj',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107acf',
  organization: devSandboxOrganization,
  secondaryOrganizations: [
    riskManagerOrganization,
    auditOnPlatformDevOrganization,
    artemisTestingOrganization,
  ],
  password: 'asdQWE1234',
});

export const devMonitoringUser: LaunchpadUser = getLaunchpadUser({
  email: 'ddaradics+monitoring@diligent.com',
  name: 'David Daradics',
  highbondId: 'GYW2JYGhseRzdQ3sGWLN',
  id: '98519a59-a041-4b81-b116-95fee7db1069',
  organization: devSolarisMonitoringOrganization,
  password: 'asdQWE123',
});

// Local environment users (with AuthObject)
export const localTestUser: LaunchpadUser & AuthObject = {
  ...getLaunchpadUser({
    email: 'local.test@example.com',
    name: 'local test',
    highbondId: 'localHighbondId',
    id: '74562189-6e3b-40b2-b0fe-72ad5416eacb',
    organization: localSandboxOrganization,
    password: 'asdQWE123',
  }),
  uid: 'localHighbondId',
  org_id: localSandboxOrganization.highbondId,
  jwt: 'localHighbondId',
};

export const localAdminTestUser: LaunchpadUser & AuthObject = {
  ...getLaunchpadUser({
    email: 'localadmin.test@example.com',
    name: 'localAdmin test',
    highbondId: 'localAdminHighbondId',
    id: '74562189-6e3b-40b2-b0fe-72ad5416eacc',
    organization: localSandboxOrganization,
    userType: 'admin',
    password: 'asdQWE123',
  }),
  uid: 'localAdminHighbondId',
  org_id: localSandboxOrganization.highbondId,
  jwt: 'localAdminHighbondId',
};

export const authorizationTestUser: LaunchpadUser & AuthObject = {
  ...getLaunchpadUser({
    email: 'authorization.test@example.com',
    name: 'Authorization Test',
    highbondId: 'authorizationHighbondId',
    id: '0192240a-2bfb-7e35-a09e-6b03cc542957',
    organization: authorizationTestOrganization,
    password: 'asdQWE123',
  }),
  uid: 'authorizationHighbondId',
  org_id: authorizationTestOrganization.highbondId,
  jwt: 'authorizationHighbondId',
};

export const authorizationTestAdminUser: LaunchpadUser & AuthObject = {
  ...getLaunchpadUser({
    email: 'admin.authorization.test@example.com',
    name: 'Authorization Test Admin',
    highbondId: 'authorizationAdminHighbondId',
    id: '0aa2aaaa-2bfb-7e35-a09e-6b03cc542957',
    organization: authorizationTestOrganization,
    userType: 'admin',
    password: 'asdQWE123',
  }),
  uid: 'authorizationAdminHighbondId',
  org_id: authorizationTestOrganization.highbondId,
  jwt: 'authorizationAdminHighbondId',
};

const teamUsers = getLaunchpadUsers([
  {
    email: 'pgerencser@diligent.com',
    highbondId: 'Z41hnvGyuzSooN8xg_Yx',
    name: 'Peter Gerencser',
    id: '9784b0d2-4bae-4217-9175-f9b01b4e445e',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'asomlai@diligent.com',
    name: 'Andras Somlai',
    highbondId: 'DQHf7VYCkB_me62LCodW',
    id: '9984a0d2-6bae-4207-9155-f9b01b4e4ffe',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'rhalmagyi@diligent.com',
    name: 'Ruben Halmagyi',
    highbondId: '8YsRyVvCychyRs7tj6Xe',
    id: 'b984a0d2-6bae-4207-9155-f9b01b4e4f2e',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'bkecskes@diligent.com',
    name: 'Boldizsár Kecskés',
    highbondId: 'tYywrSh99BqAujxi_1WZ',
    id: '1884a0d2-6bae-4207-9165-f9b21b4e4f2e',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'bkecskes+b@diligent.com',
    name: 'Boldizsár Test B',
    highbondId: 'qyT7YEjBNPukUkZciD6n',
    id: '1895a0d2-6bae-4207-9165-f9b21b4e4f2e',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits@diligent.com',
    name: 'Matyas Sinkovits',
    highbondId: 'Vj1KMpSdoMfM5zsw8f3Q',
    id: 'a984a0d2-6bae-4207-9155-f9b01b3e4fee',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+aa1@diligent.com',
    name: 'Matyas Action Approver 1 Sinkovits',
    highbondId: 'yxBstsxaJ_QxzyLvbuib',
    id: '3acb33bd-0b89-4b64-8595-83186a74dde1',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+actionapprover2@diligent.com',
    name: 'Matyas Action Approver 2 Sinkovits',
    highbondId: 'mjWCLHZ1Lx3zsL7SxZqF',
    id: '222b2166-ce9e-4acd-8721-5e04fe27f580',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+action_owner1@diligent.com',
    name: 'Matyas ACTIONOWNER 1 Sinkovits',
    highbondId: 'a85-PPEMhwVxJDtcvhsH',
    id: '4ea7f06c-905c-4822-bd5b-d9fa493e5314',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+action_owner2@diligent.com',
    name: 'Matyas ACTIONOWNER 2 Sinkovits',
    highbondId: 'K-McPDJxzC_yt8fhL8Ns',
    id: 'f45138e1-20eb-4e76-8601-1435f51443bf',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+im@diligent.com',
    name: 'Matyas IM Sinkovits',
    highbondId: '_msXPKEhc9STJybXfxcY',
    id: 'd485a33c-0a94-4fe6-b445-4ca0fd7e008e',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+alternativesysadmin@diligent.com',
    name: 'Matyas Sinkovits',
    highbondId: 'Lj5BRGpXLsbNvhjSU6v6',
    id: '0b05288c-03a4-4a62-b5d8-f511b846cfb7',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+ia1@diligent.com',
    name: 'Matyas Sinkovits Issue approver1',
    highbondId: 'jXVh27eadMDy7DGeCFKj',
    id: '54daf81d-ba6b-4c4f-8882-cfbfa31d7c47',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+io1@diligent.com',
    name: 'Matyas Sinkovits Issue owner1',
    highbondId: '-zvFzrsCdz1Pzn9WevKK',
    id: '464438f4-8019-44dc-bc64-9ae9114d7b21',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+ir1@diligent.com',
    name: 'Matyas Sinkovits issue reporter1',
    highbondId: 'zxc6sKvsMjaUoQ1ssdoH',
    id: '81282156-fd27-40db-831b-1e8cfe5e7d3d',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+type_manager1@diligent.com',
    name: 'Matyas TYPE_MANAGER 1 Sinkovits',
    highbondId: 'dQgbPs7kyUarZAjTe8x3',
    id: 'fecb25c3-75f1-486e-84c1-f99069020079',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'msinkovits+type_manager2@diligent.com',
    name: 'Matyas TYPE_MANAGER 2 Sinkovits',
    highbondId: 'tN-vuaKwK3fc-esduR7c',
    id: '9a0751cd-5c34-4a03-beda-dbc40078bd6d',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'gkorodi@diligent.com',
    name: 'Gergo Korodi',
    highbondId: 'YqeH3s8RFasoYAV1GweT',
    id: '11308d56-e1db-467d-8124-4e894df6bfa5',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'jzabala@diligent.com',
    name: 'Javier Zabala',
    highbondId: 'd2hiqRcszWpkNWwn36eD',
    id: '7a49c3d2-a172-4b07-ab19-4a97ed107ace',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz@diligent.com',
    name: 'Marta Grosz',
    highbondId: 'mh9XwQYsgKdYnJz16V9H',
    id: 'f1e2d3c4-b5a6-9788-c1d2-e3f4a5b6c7d8',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+sysadmin@diligent.com',
    name: 'Marta Grosz',
    highbondId: 'UgLkZzky1BZXrXufwjpk',
    id: 'a1b2c3d4-e5f6-7890-a1b2-c3d4e5f6a7b8',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+tm@diligent.com',
    name: 'Automation - TypeManager QA - STG',
    highbondId: 'rGDuRHGvZ8zPha3N-_NA',
    id: 'b2c3d4e5-f6a7-8901-b2c3-d4e5f6a7b8c9',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+aa@diligent.com',
    name: 'Marta Grosz AA',
    highbondId: 'qsSxxvzQnXTSxSeoekmh',
    id: 'c3d4e5f6-a7b8-9012-c3d4-e5f6a7b8c9d0',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+aa2@diligent.com',
    name: 'Marta Grosz AA 2',
    highbondId: 'MKakGZ8Sev5H3u_vuyi9',
    id: 'd4e5f6a7-b8c9-0123-d4e5-f6a7b8c9d0e1',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+ao@diligent.com',
    name: 'Marta Grosz AO',
    highbondId: 'n_gGmxvb8mV-mosN1yEF',
    id: 'e5f6a7b8-c9d0-1234-e5f6-a7b8c9d0e1f2',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+ao2@diligent.com',
    name: 'Marta Grosz AO 2',
    highbondId: 'BUad34BFVXFfRhdp8XcV',
    id: 'f6a7b8c9-d0e1-2345-f6a7-b8c9d0e1f2a3',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+tm2@diligent.com',
    name: 'Marta Grosz TM 2',
    highbondId: 'TEE98h5tm1twJsV6N5um',
    id: 'a7b8c9d0-e1f2-3456-a7b8-c9d0e1f2a3b4',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+ia@diligent.com',
    name: 'Automation - IssueApprover QA - STG',
    highbondId: 'avNjy5wfxQbFzFfzLk1j',
    id: 'b8c9d0e1-f2a3-4567-b8c9-d0e1f2a3b4c5',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+im@diligent.com',
    name: 'Marta Grosz IM',
    highbondId: 'qzWmbn294pu6AREyQnE_',
    id: 'c9d0e1f2-a3b4-5678-c9d0-e1f2a3b4c5d6',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+io@diligent.com',
    name: 'Automation - IssueOwner QA - STG',
    highbondId: 'abq3T4wZf3z2L-UYUqiE',
    id: 'd0e1f2a3-b4c5-6789-d0e1-f2a3b4c5d6e7',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'mgrosz+ir@diligent.com',
    name: 'Marta Grosz IR',
    highbondId: 'rzBSyG_zfiTNbmA1jZZ1',
    id: 'e1f2a3b4-c5d6-7890-e1f2-a3b4c5d6e7f8',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    id: 'ae232250-7117-11f0-9f53-e56990cbaa39',
    name: 'Daniel Hatas',
    email: 'dhatas@diligent.com',
    highbondId: 'Ys2HuLE3JpXeFUzPW2xb',
    userType: 'admin',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    id: '8022be1f-5dfe-4a6d-bec6-1084ca7d1e3e',
    name: 'Daniel Hatas (Issue Reporter)',
    email: 'dhatas+im-issuereporter@diligent.com',
    highbondId: 'dvRGbAFn6Sxjfxzc7XaU',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'lbalint@diligent.com',
    name: 'Levente Balint',
    highbondId: 'q5Vgsr-yvDBH8GPyGhyf',
    id: '0c67315f-1585-463b-b049-a776b54186ef',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'ibravo@diligent.com',
    name: 'Ivan Bravo',
    highbondId: 'QCHAosx6jH9Z8mTQhFWU',
    id: '70a2388d-907c-46bb-8e85-83f1b5a772a9',
    organization: devSandboxOrganization,
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
  {
    email: 'ibravo+admin@diligent.com',
    name: 'Ivan Bravo',
    highbondId: 'QCHAosx6jH9Z8mTQhFWU',
    id: '70a2388d-907c-46bb-8e85-83f1b5a772a9',
    organization: devSandboxOrganization,
    userType: 'admin',
    secondaryOrganizations: [
      riskManagerOrganization,
      auditOnPlatformDevOrganization,
      artemisTestingOrganization,
    ],
  },
]);

// Environment-specific arrays for seeders
export const localIssueManagerTestUsers: LaunchpadUser[] = [
  localTestUser,
  localAdminTestUser,
  authorizationTestUser,
  authorizationTestAdminUser,
];

export const devIssueManagerTestUsers: LaunchpadUser[] = [
  ...teamUsers,
  devAdminTestUser,
  devTestUser,
  devMonitoringUser,
];
